import {
  IndexInvestorTransactionsOutputShape,
} from "@api/services/transactions"


const TransactionShape = IndexInvestorTransactionsOutputShape

export default TransactionShape
